module.exports = __webpack_public_path__ + "media/images/subject_img/ACCOUNTING-FINANCE-f3f6153b484c3d9480c77f11437897f7.jpg";